export default "__VITE_ASSET__9EGpy1wm__"